import React, { useState } from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Button from "../../../atoms/button";
import EmailIcon from "../../../atoms/icons/email";
import { submitNewsLetter } from "../../../helper/api";
import { readCookie } from "../../../helper/cookies";

import translate from "../../../translate";

import "./news-letter.m.css";

const NewsLetter = ({ id, token, publisherName }) => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [successClass, setSuccessClass] = useState("");
  const [valid, setValid] = useState(false);

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    return re.test(email);
  };

  const updateEmailField = (e) => {
    setEmail(e.target.value);
  };

  const handleFocus = () => setValid(false);

  const submitEmail = () => {
    if (!validateEmail(email)) {
      setValid(true);
      return;
    }

    const thinmint = readCookie("thinmint");

    const body = {
      email_address: email,
      status: "subscribed",
      merge_fields: {
        DEVICEID: thinmint,
      },
    };

    submitNewsLetter(id, token, body)
      .then((text) => {
        setEmail(text);
        window.dataLayer.push({
          event: "subscribeNewsLetter",
        });
        const parsedUserFields = JSON.parse(window.localStorage.getItem("USER:GTM"));
        parsedUserFields.connect_level += ", NewsLetter - Yes";
        window.dataLayer.push(parsedUserFields);
      })
      .catch((text) => {
        setEmail(text);
        setSuccessClass("failure");
      })
      .finally(() => {
        setSuccess(true);
      });
  };

  return (
    <div styleName="news-letter">
      <div styleName="headline-title-wrapper">
        <div styleName="title">{translate(publisherName, "stay_updated")}</div>
        <div styleName="div-line"></div>
      </div>
      <p styleName="info-text">{translate(publisherName, "stay_tunned_newsletter")}</p>
      <div styleName="text-field-wrapper">
        <div styleName="text-filed-icon">
          {!success ? <EmailIcon /> : null}
          <input
            type="email"
            value={email}
            onChange={updateEmailField}
            placeholder={translate(publisherName, "email")}
            styleName={`text-field ${successClass}`}
            disabled={success}
            onFocus={handleFocus}
          />
        </div>
        <Button content={translate(publisherName, "subscribe")} onClick={submitEmail} disabled={success} />
      </div>
      {valid && <span styleName="invalid">Invalid Email</span>}
      <span styleName="help-text">{translate(publisherName, "join_over_subscribers")}</span>
    </div>
  );
};

NewsLetter.propTypes = {
  id: string,
  token: string,
  publisherName: string,
};

const mapStateToProps = (state) => {
  const item = get(state, ["qt", "config", "publisher-attributes", "mailchimp"], {});

  return {
    id: item.listId,
    token: item.token,
    publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  };
};

export default connect(mapStateToProps, null)(NewsLetter);
